import React from "react";
import style from "./style.module.css";
import ImageLoader from "../../other-components/ImageLoader";
import Button from "../../UI/Button/ui";
import { useNavigate } from "react-router-dom";

function Modal({ title, description, data, spaceAbove }) {
    const navigate = useNavigate();

    return (
        <div className={`${style.parentView} ${spaceAbove ? style.space1X : ''}`}>
            {title ?
                <div className={style.headerView}>
                    <h2>{title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                : null
            }

            <div className={[style.contentsView].join(" ")}>
                <ImageLoader
                    className={`${style.imageView} lazy-loading`}
                    src={data[0].item_media}
                    alt={'container v8 image'}
                    action={{ onClick: () => navigate("/" + data[0].item_slug, { replace: false }) }}
                />

                <div className={style.childView}>
                    <h2>{data[0].item_title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: data[0].item_description }} />

                    <Button text="Explore now"
                        rounded={true}
                        hoverEffect={true}
                        spaceTop={25}
                        action={{ onClick: () => navigate("/" + data[0].item_slug, { replace: false }) }} />
                </div>
            </div>
        </div>
    );
}

export default Modal;